import map from 'lodash/map'
import keyBy from 'lodash/keyBy'
import get from 'lodash/get'
import groupBy from 'lodash/groupBy'
import orderBy from 'lodash/orderBy'

export const getters = {
  isLoadingProjects (state) {
    return !state.projects
  },
  isLoadingPackages (state) {
    return !state.packages
  },
  isLoadingCatalog (state) {
    return !state.catalog
  },
  isLoadingRulesModule (state) {
    return getters.isLoadingProjects(state) || getters.isLoadingPackages(state)
  },
  getProjects (state) {
    return state.projects
  },
  getPackages (state) {
    return orderBy(state.packages, ['name'], ['asc'])
  },
  projectsByCategory (state) {
    if (state.projects) {
      let categories = map(groupBy(state.projects, 'category'), (projects, category) => ({
        name: category,
        projects: orderBy(projects, ['name'], ['asc'])
      }))
      return orderBy(categories, ['name'], ['asc'])
    } else {
      return []
    }
  },
  projectTreeData (state) {
    const projectsCopy = (state.projects || []).map((project) => {
      project.category = project.category || 'No category'
      return project
    })
    return [{
      id: 'projects',
      label: 'Projects',
      root: true,
      route: { name: 'rules:projects' },
      children: orderBy(map(groupBy(projectsCopy, 'category'), (projects, category) => ({
        id: category,
        label: category,
        children: orderBy(projects, ['name'], ['asc']).map((project) => ({
          id: project.id,
          label: project.name,
          route: { name: 'rules:project', params: { projectId: project.id } }
        }))
      })), ['label'], ['asc'])
    }]
  },
  packageTreeData (state) {
    return [{
      id: 'packages',
      label: 'Packages',
      root: true,
      route: { name: 'rules:packages' },
      children: map(orderBy(state.packages, ['name'], ['asc']) || [], (p) => ({
        id: p.id,
        label: p.name,
        route: { name: 'rules:package', params: { packageUuid: p.id } }
      }))
    }]
  },
  catalogMap (state) {
    return keyBy(state.catalog, (o) => o.name)
  },
  getActiveProject: (state) => () => {
    return state.activeProject
  },
  getActiveProjectProdVersion (state) {
    return state.activeProject.prod
  },
  activeProjectVersionsMapByEffectiveDate (state) {
    return keyBy(state.activeProject.versions, (o) => o.effective_date)
  },
  uncommittedComponentsCount (state) {
    return get(getters.uncommittedComponents(state), 'length', 0)
  },
  uncommittedComponentsMapById (state) {
    return keyBy(state.uncommittedComponents, (c) => c.id)
  },
  uncommittedComponents (state) {
    const changes = state.uncommittedComponents.value
    if (!changes) {
      return []
    }
    let components = [
      ...changes.added.map((c) => ({
        ...c,
        change: 'added'
      })),
      ...changes.updated.map((c) => ({
        ...c,
        change: 'updated'
      })),
      ...changes.deleted.map((c) => ({
        ...c,
        change: 'deleted'
      })),
    ]
    return components
  },
  uncommittedComponentsStatus (state) {
    return {
      loaded: state.uncommittedComponents.loaded,
      loading: state.uncommittedComponents.loading,
      error: state.uncommittedComponents.error
    }
  }
}
